(function () {
    'use strict';

    angular.module("imApp").factory("customsTarifMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getCustomsTarifMenu: function (parms) {
                return $ihttp.post({
                    method: 1726,
                    parameters: parms || {}
                });
            },
            deleteItem: function (menu) {
                return $ihttp.post({
                    method: 1729,
                    parameters: menu
                });
            }
        };

        return service;
    }]);
})();
